'use strict';

var format = require('date-fns/format');
var constants = require('../constants.cjs');
var parsers = require('../parsers.cjs');
var disassembleISODatePartToParts = require('../utils/disassembleToParts/disassembleISODatePartToParts.cjs');
var getLocaleData = require('../utils/getLocaleData.cjs');
var getFormatStringForTimeRangePreset = require('./formatStrings/getFormatStringForTimeRangePreset.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var format__default = /*#__PURE__*/_interopDefault(format);

const formatISODatePartInterval = (params) => {
  const {
    presetName,
    isoDatePartInterval,
    locale,
    endDateAlt = constants.DEFAULT_END_DATE_ALTERNATIVE
  } = params;
  const localeData = getLocaleData(locale);
  const isSameYear = isoDatePartInterval.end !== void 0 && disassembleISODatePartToParts(isoDatePartInterval.end).year === disassembleISODatePartToParts(isoDatePartInterval.start).year;
  const [fromFormatString, toFormatString] = getFormatStringForTimeRangePreset.getFormatStringForTimeRangePreset(
    isSameYear ? getSameYearPresetNames(presetName) : presetName,
    locale
  );
  const startDate = parsers.isoDatePartToDate(isoDatePartInterval.start);
  const formattedStart = format__default(startDate, fromFormatString, {
    locale: localeData
  });
  if (isoDatePartInterval.end === void 0) {
    return `${formattedStart} \u2013 ${endDateAlt}`;
  }
  const endDate = parsers.isoDatePartToDate(isoDatePartInterval.end);
  const formattedEnd = format__default(endDate, toFormatString, {
    locale: localeData
  });
  return `${formattedStart} \u2013 ${formattedEnd}`;
};
const getSameYearPresetNames = (presetName) => {
  switch (presetName) {
    case "year_month":
      return "year_month_same_year";
    case "date":
      return "date_same_year";
    case "date_short":
      return "date_short_same_year";
    case "date_weekday":
      return "date_weekday_same_year";
    case "date_weekday_short":
      return "date_weekday_short_same_year";
    default:
      return presetName;
  }
};

module.exports = formatISODatePartInterval;
//# sourceMappingURL=formatISODatePartInterval.cjs.map
